import { useState } from 'react';
import Swal from 'sweetalert2';

export default function Contato() {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, value.toString());
    });

    setLoading(true);

    try {
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content');
        
      const response = await fetch(
        'https://portal.exatocalculos.com.br/sendamail-exato',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRF-TOKEN': csrfToken

          },
          body: body.toString(),
        }
      );

      if (response.status === 200) {
        setSubmitted(true);
        form.reset();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Falha no envio',
          text: 'Houve uma falha ao enviar a mensagem. Tente novamente.',
          confirmButtonText: 'OK'
        });      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Falha no envio',
        text: 'Houve uma falha ao enviar a mensagem. Tente novamente.',
        confirmButtonText: 'OK'
      });    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contato" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div>
            <span className="inline-block text-xs font-bold tracking-widest uppercase text-sky-500 mb-4">Fale Conosco</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
              Solicite um orçamento ou tire suas dúvidas
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-10">
              Nossa equipe está pronta para apresentar a melhor solução para o seu escritório. Preencha o formulário e entraremos em contato em breve.
            </p>

            <div className="space-y-5">
              {[
                { icon: 'ri-mail-line', label: 'E-mail', value: 'exato.trabalhista@gmail.com' },
                { icon: 'ri-phone-line', label: 'Telefone', value: '(11) 9.9468-8228' },
                { icon: 'ri-map-pin-line', label: 'Localização', value: 'São Paulo, SP — Brasil' },
              ].map((info) => (
                <div key={info.label} className="flex items-center gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-sky-50 border border-sky-100 shrink-0">
                    <i className={`${info.icon} text-sky-500 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-xs text-gray-400 mb-0.5">{info.label}</div>
                    <div className="text-sm font-medium text-gray-700">{info.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="bg-gray-50 rounded-3xl p-8 border border-gray-100">
            {submitted ? (
              <div className="flex flex-col items-center justify-center py-12 text-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-emerald-50 border border-emerald-100">
                  <i className="ri-check-line text-emerald-500 text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">Mensagem enviada!</h3>
                <p className="text-gray-500 text-sm max-w-xs">Recebemos seu contato e retornaremos em breve. Obrigado!</p>
              </div>
            ) : (
              <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <input
                      type="hidden"
                      name="to"
                      value="exato.trabalhista@gmail.com"
                    />
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">Nome completo</label>
                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Seu nome"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-sky-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1.5">E-mail</label>
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="seu@email.com"
                      className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-sky-400 transition-colors"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Telefone / WhatsApp</label>
                  <input
                    type="text"
                    name="telefone"
                    placeholder="(00) 00000-0000"
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-sky-400 transition-colors"
                  />
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Interesse</label>
                  <select
                    name="interesse"
                    required
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-700 focus:outline-none focus:border-sky-400 transition-colors cursor-pointer"
                  >
                    <option value="">Selecione uma opção</option>
                    <option value="Cálculos Trabalhistas">Cálculos Trabalhistas</option>
                    <option value="Curso Exclusivo">Curso Exclusivo</option>
                    <option value="Plataforma de Gestão">Plataforma de Gestão</option>
                    <option value="Outros">Outros</option>
                  </select>
                </div>

                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">Mensagem</label>
                  <textarea
                    name="mensagem"
                    rows={4}
                    maxLength={500}
                    placeholder="Descreva sua demanda..."
                    className="w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:border-sky-400 transition-colors resize-none"
                  />
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-3.5 rounded-xl text-white font-semibold text-sm cursor-pointer whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5 disabled:opacity-60"
                  style={{ background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)' }}
                >
                  {loading ? (
                    <span className="inline-flex items-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i>
                      Enviando...
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-2">
                      <i className="ri-send-plane-line"></i>
                      Enviar mensagem
                    </span>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
